export default function ABS(props) {
  return (
    <svg width='21.883' height='16.22' viewBox='0 0 21.883 16.22' fill='#fff' {...props}>
      <g transform='translate(0 0)'>
        <path
          d='M2339.564,364.324l-.128.875a10.28,10.28,0,0,1-1.19,3.513c-.277.5-.6.971-.917,1.473l-1.112-.856a9.593,9.593,0,0,0-.666-12.414l.942-1.074c.448.58.885,1.092,1.261,1.646a10.684,10.684,0,0,1,1.668,4.174c.05.278.066.562.1.843a1.087,1.087,0,0,0,.043.156Z'
          transform='translate(-2317.681 -355.486)'
        />
        <path
          d='M2012.641,363.053q.063-.415.126-.83a10.3,10.3,0,0,1,1.656-4.287c.383-.568.822-1.1,1.261-1.68l1.03.984a9.6,9.6,0,0,0-.725,12.481l-1.1.85c-.266-.412-.542-.812-.789-1.228a10.573,10.573,0,0,1-1.305-3.583c-.051-.285-.07-.575-.106-.863a1.713,1.713,0,0,0-.043-.181Z'
          transform='translate(-2012.641 -355.878)'
        />
        <path
          d='M2081.338,357.537a8.122,8.122,0,1,1-8-8.114A8.125,8.125,0,0,1,2081.338,357.537Zm-8.115,6.721a6.727,6.727,0,1,0-6.742-6.8A6.692,6.692,0,0,0,2073.222,364.257Z'
          transform='translate(-2062.191 -349.422)'
        />
        <path
          d='M2191.4,452.488c.571,0,1.138-.017,1.7.008a2.283,2.283,0,0,1,.757.171,1.371,1.371,0,0,1,.051,2.363,1.164,1.164,0,0,1,.722.678,1.687,1.687,0,0,1,.077.981,1.344,1.344,0,0,1-1.25,1.094c-.679.041-1.362.009-2.061.009Zm1.134,4.324c.374-.007.764.089.973-.3a.664.664,0,0,0-.066-.76c-.243-.291-.583-.217-.907-.208Zm-.005-2.184c.34.021.667.063.886-.251a.7.7,0,0,0-.034-.686c-.237-.259-.546-.208-.852-.2Z'
          transform='translate(-2181.505 -446.779)'
        />
        <path
          d='M2112.852,457.569c-.4,0-.777,0-1.153-.006-.045,0-.114-.072-.127-.123-.071-.272-.129-.549-.193-.834H2110.2c-.075.315-.15.629-.227.952h-1.207c.071-.306.136-.6.208-.9.341-1.408.685-2.816,1.023-4.225.038-.159.1-.234.281-.224.362.019.725.01,1.088,0,.146,0,.217.023.257.192.4,1.669.808,3.334,1.215,5A1.428,1.428,0,0,1,2112.852,457.569Zm-2.042-4.084-.047.012-.427,2.146h.885Z'
          transform='translate(-2103.444 -446.523)'
        />
        <path
          d='M2261.078,450.386l-.609.861a4.407,4.407,0,0,0-.517-.261.536.536,0,0,0-.665.22.551.551,0,0,0,.2.743c.32.207.674.369.972.6a1.54,1.54,0,0,1,.5,1.708,1.5,1.5,0,0,1-1.2,1.166,2.1,2.1,0,0,1-1.928-.566l.573-.838a6.535,6.535,0,0,0,.814.311.459.459,0,0,0,.559-.279.545.545,0,0,0-.2-.691c-.237-.155-.488-.288-.734-.427a1.547,1.547,0,0,1-.759-1.744,1.475,1.475,0,0,1,1.156-1.27A1.886,1.886,0,0,1,2261.078,450.386Z'
          transform='translate(-2244.267 -444.293)'
        />
      </g>
    </svg>
  )
}
